// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyCuhI0kt8VzP7uNw_HHzHLsCaIq5L5Xv2U",
    authDomain: "sofben-48841.firebaseapp.com",
    projectId: "sofben-48841",
    storageBucket: "sofben-48841.firebasestorage.app",
    messagingSenderId: "336539410002",
    appId: "1:336539410002:web:fb9c41b25456e0da8f498b"
  };

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const sendApprovalEmail = httpsCallable(functions, 'sendApprovalEmail');
